import React from 'react'
import { Link } from 'react-router-dom'

class iOSAppNavi extends React.Component {
  render(){
    return(
      <div>
        <Link to="/iOSApp/Ruchen">Ruchen</Link>
        <br/>
        <Link to="/iOSApp/LAZY">LAZY</Link>
      </div>
    )
  }
}

export default iOSAppNavi;